import {RangePipe} from './range-pipe/range.pipe';
import {NgModule} from '@angular/core';
import {DateWithTimezonePipe} from './date-with-timezone-pipe/date-with-timezone.pipe';

@NgModule({
  declarations: [DateWithTimezonePipe, RangePipe],
  exports: [DateWithTimezonePipe, RangePipe],
})
export class SharedPipesModule {}
